import { render, staticRenderFns } from "./SimpleProduct.vue?vue&type=template&id=5a591fce&scoped=true&"
import script from "./SimpleProduct.vue?vue&type=script&lang=ts&"
export * from "./SimpleProduct.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleProduct.vue?vue&type=style&index=0&id=5a591fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a591fce",
  null
  
)

export default component.exports